import { InfoRow } from "@components/info-row";
import { PLAN_APP_NAMES, PlanAppSettings } from "@utils/product/plan-apps";

interface Props {
  /** The applications the plan opens, null for plans that do not carry them */
  appSettings: PlanAppSettings | null;

  /** The alignment of the labels */
  labelTextAlign?: "left" | "right";
}

/** Displays the viewer and dashboard applications a plan opens */
export function PlanAppInfoRows({
  appSettings,
  labelTextAlign,
}: Props): React.JSX.Element | null {
  if (!appSettings) {
    return null;
  }

  return (
    <>
      <InfoRow
        labelTextAlign={labelTextAlign}
        label="Viewer Application"
        info={PLAN_APP_NAMES[appSettings.defaultViewerApp]}
      />

      <InfoRow
        labelTextAlign={labelTextAlign}
        label="Dashboard Application"
        info={PLAN_APP_NAMES[appSettings.defaultDashboardApp]}
      />
    </>
  );
}
